@if(isOpen)
{
<div class="relative w-full rounded-xl border border-border shadow-md">
    <div class="p-6 flex flex-col gap-2">
        <p class="font-bold text-lg">
            @if(isEditing) { {{ 'admin.edit' | transloco }} }
            @else { {{ 'admin.new' | transloco }} }
            {{ 'admin.products_services' | transloco }}</p>

        <!-- Name -->
        <div class="min-w-[250px] max-w-ultrawide">
            <app-labeled-input labelText="{{ 'admin.name' | transloco }}" [inputId]="'name'" [inputType]="'text'"
                [(inputValue)]="nameInput" [errorMessage]="nameInputError"
                placeholder="{{ 'admin.placeholders.eg_remainining_contract_duration' | transloco }}"></app-labeled-input>
        </div>

        <!-- Type -->
        <div class="min-w-[250px] max-w-ultrawide">
            <app-custom-dropdown [options]="typeDropdownOptions" label="{{ 'shared.type' | transloco }}"
                [(selectedOption)]="selectedTypeDropdown">
            </app-custom-dropdown>
        </div>

        <!-- Description -->
        <div class="min-w-[250px] max-w-ultrawide">
            <app-textarea-input labelText="{{ 'admin.description' | transloco }}" [inputId]="'description'"
                [(textValue)]="descriptionInput" [errorMessage]="descriptionInputError"
                boxHeight="h-[150px]"></app-textarea-input>
        </div>

        <!-- Target Segments -->
        <div class="w-full max-w-ultrawide mt-4">
            <div class="flex items-end gap-2">
                <div class="w-[400px] mobile:w-[250px] max-w-ultrawide">
                    <app-labeled-input labelText="{{ 'admin.target_segments' | transloco }}" [inputId]="'segment'"
                        [inputType]="'text'" [(inputValue)]="segmentInput"
                        placeholder="{{ 'admin.target_segments_placeholder' | transloco }}"
                        boxHeight="h-[50px]"></app-labeled-input>
                </div>

                <button type="button" (click)="addSegment()"
                    class="px-4 py-2 h-[50px] rounded-xl bg-neutral-200 hover:bg-neutral-300 text-neutral-800">
                    {{ 'shared.add' | transloco}}
                </button>
            </div>

            <!-- Segments -->
            <div class="flex flex-wrap gap-2 mt-3">
                <div *ngFor="let seg of targetSegments; index as i"
                    class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-success-100">
                    <span class="text-base text-success-800">{{ seg }}</span>
                    <button type="button" (click)="removeSegment(i)" aria-label="Remove"
                        class="w-5 h-5 rounded-full text-success-800 hover:text-success-900 text-sm leading-none">
                        X
                    </button>
                </div>
            </div>
        </div>


        <div class="flex gap-2 flex-wrap min-w-[300px]">
            <div class="h-[45px] w-[150px]">
                @if(isEditing)
                {
                <app-custom-button buttonText="{{ 'admin.update' | transloco }}" backgroundColor="bg-primary"
                    textColor="text-white" borderColor="border-primary" (buttonClick)="confirmButtonClick()"
                    hoverBackgroundColor="hover:bg-primary-1200"></app-custom-button>}
                @else {
                <app-custom-button buttonText="{{ 'admin.create' | transloco }}" backgroundColor="bg-primary"
                    textColor="text-white" borderColor="border-primary" (buttonClick)="confirmButtonClick()"
                    hoverBackgroundColor="hover:bg-primary-1200"></app-custom-button>}
            </div>

            <div class="h-[45px] w-[150px]">
                <app-custom-button buttonText="{{ 'shared.cancel' | transloco }}" backgroundColor="bg-[#FFFFFF]"
                    textColor="text-secondary" borderColor="border-secondary" hoverBackgroundColor="hover:bg-secondary"
                    hoverBorderColor="hover:border-secondary" (buttonClick)="closeView()"></app-custom-button>
            </div>
        </div>
    </div>
</div>
}